import type { FC, ReactNode } from 'react'
import type { Wallpaper } from '@/types'

import { cn } from '@/lib/utils'
import { WallpaperCard } from '@/components/wallpapers/wallpaper-card'

interface WallpaperMasonryProps {
    wallpapers: Array<Wallpaper>
    preloadFirst?: boolean
    className?: string
}

// Mixed desktop and phone wallpapers keep their real shape in a balanced column layout.
export const WallpaperMasonry: FC<WallpaperMasonryProps> = ({ wallpapers, preloadFirst = false, className }): ReactNode => {
    return (
        <ul className={cn('columns-2 gap-3 sm:gap-4 md:columns-3 xl:columns-4', className)}>
            {wallpapers.map((wallpaper, index) => (
                <li key={wallpaper.id} className='mb-3 break-inside-avoid sm:mb-4'>
                    <WallpaperCard wallpaper={wallpaper} preload={preloadFirst && index < 2} />
                </li>
            ))}
        </ul>
    )
}
